class PrintJob {

  /** @type {String} */ 
  uuid

  constructor (data) {
    this.uuid = data.uuid
  }
}

export default PrintJob